import {
  DataBase,
  ChartLine,
  Stethoscope,
  Notebook,
  Chemistry,
} from "@carbon/icons-react";

export function buildMenuItems(role) {
  const isPatient = role === "patient";
  const isExpert = role === "expert_physician";

  // 先頭のプライマリ操作
  let primary = null;
  if (isPatient) {
    primary = { label: "AI問診を始める", to: "/pre-interview", kind: "primary" };
  } else if (!isExpert) {
    // 主治医のみ「診察を記録する」
    primary = { label: "診察を記録する", to: "/consultation", kind: "primary" };
  }

  // 医師／EP 共通メニュー
  const MENU_COMMON = [
    {
      label: "主訴・診察履歴",
      to: "/consultation-records",
      icon: <Stethoscope />,
    },
    {
      label: "AI問診結果：時系列スコア",
      to: "/ai-interview-scores",
      icon: <ChartLine />,
    },
    {
      label: "AI問診結果：質問",
      to: "/ai-interview-questions",
      icon: <DataBase />,
    },
    {
      label: "検査結果：PRO・客観的指標",
      to: "/test-results",
      icon: <Chemistry />,
    },
    {
      label: "基本情報",
      to: "/basic-info",
      icon: <Notebook />,
    },
  ];

  // 患者はプライマリのみ、主治医はプライマリ＋共通、エキスパート医師は共通のみ
  if (isPatient) return [primary];
  if (isExpert) return [...MENU_COMMON];
  return [primary, ...MENU_COMMON];
}
